import { render, staticRenderFns } from "./courseTemplate.vue?vue&type=template&id=50e90d18&"
import script from "./courseTemplate.vue?vue&type=script&lang=js&"
export * from "./courseTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports